import request from '../../utils/request'

// 查询
export function getMiniProgrammeDTO (data) {
  return request.post('/system/dictData/getMiniProgrammeDTO')
}

// 修改
export function updateById (data) {
  return request.post('/system/dictData/updateMiniProgrammeDTO', data)
}